import dayjs from "utils/dayjs";

dayjs.tz.setDefault("Asia/Saigon");
// dayjs.tz.setDefault("UTC+7");

export const formatDate = (date: any, format = "DD/MM/YYYY"): string => {
  return dayjs(date).format(format);
};
export const formatHHmmDate = (date: any): string => {
  return dayjs(date).utcOffset(7).format("HH:mm - DD/MM/YYYY");
};
export const formatHour = (val: string, format = ""): string => {
  if (format) {
    return dayjs(val, format).utcOffset(7).format("LT");
  }
  return dayjs(val).utcOffset(7).format("LT");
};

export const formatHour24 = (val: string, format = ""): string => {
  if (format) {
    return dayjs(val, format).format("HH:mm");
  }
  return dayjs(val).format("HH:mm");
};
